import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../../components/Header";
import { useContext } from "react";
import { AuthContext } from "../../utils/AuthContext";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function Checkout() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const { user } = useContext(AuthContext);
  const [userData, setUserData] = useState(null);
  const [loadingReserve, setLoadingReserve] = useState(null);
  const [rates, setRates] = useState([]);
  const [selectedRate, setSelectedRate] = useState(null);
  const [isUserReady, setIsUserReady] = useState(false);
  const navigate = useNavigate()
  
  const [guest, setGuest] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: ""
  });

  const roomId = params.get("room");
  const checkIn = params.get("checkIn");
  const checkOut = params.get("checkOut");

  const [room, setRoom] = useState(null);
  const [total, setTotal] = useState(null);

  useEffect(() => {
    if (!user) return;

    const fetchUser = async () => {
      try {
        const res = await axios.get(
          `https://api.komorotel.com/api/user/${user?._id}`,
          { withCredentials: true }
        );

        setUserData(res.data);
      } catch (err) {
        console.log(err);
      }
    };

    fetchUser();
  }, [user]);

  useEffect(() => {
    if (!userData) return;

    setGuest({
      firstName: userData.name || "",
      lastName: userData.surname || "",
      email: userData.email || "",
      phone: userData.phone || ""
    });

    setIsUserReady(true);
  }, [userData]);

  useEffect(() => {
  if (!user) {
    setIsUserReady(true);
  }
}, [user]);

  // 🔥 fetch room
  useEffect(() => {
    const fetchRoom = async () => {
      try {
        const res = await axios.get(
          `https://api.komorotel.com/api/rooms/${roomId}`
        );
        setRoom(res.data);
      } catch (err) {
        console.log(err);
      }
    };

    fetchRoom();
  }, [roomId]);

  useEffect(() => {
    if (!roomId || !checkIn || !checkOut) return;

    const fetchRates = async () => {
      try {
        const res = await axios.get(
          `https://api.komorotel.com/api/calendar/${room.hotelId}`,
          {
            params: { startDate: checkIn, endDate: checkOut },
          }
        );

        const roomData = res.data.find(r => r.roomId === roomId);

        const firstDay = roomData?.days?.[0];
        const availableRates = firstDay?.rates || [];

        setRates(availableRates);
        setSelectedRate(availableRates[0] || null);

      } catch (err) {
        console.log(err);
      }
    };

    if (room) fetchRates();
  }, [room, roomId, checkIn, checkOut]);
useEffect(() => {
  if (!selectedRate || !roomId || !checkIn || !checkOut) return;

  const fetchPrice = async () => {
    try {
      const res = await axios.get(
        `https://api.komorotel.com/api/tarifs/calculate-room-price`,
        {
          params: {
            roomId,
            ratePlanId: selectedRate.ratePlanId,
            startDate: checkIn,
            endDate: checkOut,
          },
        }
      );

      setTotal(res.data.total);
    } catch (err) {
      console.log(err);
    }
  };

  fetchPrice();
}, [selectedRate]);

  const nights =
    checkIn && checkOut
      ? Math.ceil(
          (new Date(checkOut) - new Date(checkIn)) /
            (1000 * 60 * 60 * 24)
        )
      : 0;

  const handleReserve = async () => {
  try {
    setLoadingReserve(true);
    if (!guest.email || !guest.firstName || !guest.lastName) {
      toast.error("Veuillez remplir tous les champs obligatoires");
      setLoadingReserve(false); // 🔥 IMPORTANT
      return;
    }
    if (!guest.phone || !guest.phone.startsWith("+")) {
      toast.error("Numéro invalide");
      return;
    }

    const res = await axios.post(
      "https://api.komorotel.com/api/reservation",
      {
        roomId,
        ratePlanId: selectedRate?.ratePlanId,
        checkInDate: checkIn,
        checkOutDate: checkOut,

        guest // 🔥 IMPORTANT
      },
      { withCredentials: true }
    );

    const reservation = res.data;

    if (reservation.status === "pending") {
      // 👥 GUEST
      navigate("/reservation-pending", {
        state: { email: reservation.guest.email }
      });

    } else {
      // 👤 USER CONNECTÉ
      navigate("/confirmation/" + reservation._id);
    }

  } catch (err) {
    console.log(err);
    toast.error(err.response?.data?.message || "Une erreur est survenue");
  } finally {
    setLoadingReserve(false);
  }
};

  return (
    <>
        <Header/>
        <div className="max-w-6xl mx-auto py-10 px-4 mt-6">

        <h1 className="text-2xl font-semibold mb-8">
            Finaliser la réservation
        </h1>

        <div className="grid md:grid-cols-2 gap-10">

            {/* 🔵 LEFT = RÉSUMÉ */}
            <div className="bg-white border rounded-2xl p-6">

              <h2 className="text-lg font-semibold mb-4">
                Votre séjour
              </h2>

              {/* 🏨 ROOM */}
              {room && (
                <div className="flex gap-4 mb-6">

                  <img
                    src={room.photos?.[0]}
                    alt=""
                    className="w-24 h-24 object-cover rounded-xl"
                  />

                  <div>
                    <p className="font-semibold text-gray-900">
                      {room.title}
                    </p>

                    <p className="text-sm text-gray-500">
                      {checkIn} → {checkOut}
                    </p>

                    <p className="text-sm text-gray-500">
                      {nights} nuit{nights > 1 && "s"}
                    </p>
                  </div>

                </div>
              )}

              {/* 💳 RATE SELECTION */}
              <div className="border-t pt-4">

                <h3 className="font-medium mb-3">
                  Choisissez votre tarif
                </h3>

                <div className="flex flex-col gap-3">

                  {rates.map((rate, i) => {

                    const isSelected =
                      selectedRate?.ratePlanId === rate.ratePlanId;

                    const hasPolicy = !!rate.cancellationPolicy;

                    const policy = rate.cancellationPolicy;

                    const now = new Date();
                    const checkInDate = new Date(checkIn);

                    const diffHours =
                      (checkInDate.getTime() - now.getTime()) /
                      (1000 * 60 * 60);

                    let refundText = "";
                    let policyText = "";
                    let policyColor = "text-gray-500";

                    // 🔥 CAS SANS POLICY (IMPORTANT UX)
                    if (!hasPolicy) {
                      policyText = "Conditions d’annulation à confirmer avec l’hôtel";
                      refundText = "Remboursement selon validation de l’hôtel";
                      policyColor = "text-gray-500";
                    }

                    // 🔥 FREE
                    if (hasPolicy && policy.type === "free") {
                      const isFree = diffHours >= policy.hoursBeforeArrival;

                      policyText = `Annulation gratuite jusqu’à ${policy.hoursBeforeArrival}h avant l’arrivée`;

                      refundText = isFree
                        ? "Remboursement total si annulation maintenant"
                        : "Non remboursable à cette date";

                      policyColor = isFree ? "text-green-600" : "text-red-500";
                    }

                    // 🔥 PARTIAL
                    if (hasPolicy && policy.type === "partial") {
                      const isFree = diffHours >= policy.hoursBeforeArrival;

                      policyText = `Gratuit jusqu’à ${policy.hoursBeforeArrival}h avant l’arrivée puis ${policy.penaltyPercentage}% de frais`;

                      refundText = isFree
                        ? "Remboursement total si annulation maintenant"
                        : `Remboursement ${100 - policy.penaltyPercentage}%`;

                      policyColor = "text-yellow-600";
                    }

                    // 🔥 NON REFUNDABLE
                    if (hasPolicy && policy.type === "non_refundable") {
                      policyText = "Non remboursable";
                      refundText = "Aucun remboursement";
                      policyColor = "text-red-500";
                    }

                    return (
                      <div
                        key={i}
                        onClick={() => setSelectedRate(rate)}
                        className={`
                          p-4 rounded-xl border cursor-pointer transition
                          ${isSelected
                            ? "border-[#3A9D23] bg-green-50"
                            : "hover:border-gray-300"}
                        `}
                      >

                        <div className="flex justify-between items-center">

                          {/* LEFT */}
                          <div>

                            <p className="font-medium">
                              {rate.name}
                            </p>

                            {rate.mealPlan !== "none" && (
                              <p className="text-xs text-gray-500">
                                {rate.mealPlan}
                              </p>
                            )}

                            {/* 🔥 POLICY */}
                            <p className={`text-xs mt-1 ${policyColor}`}>
                              {policyText}
                            </p>

                            {/* 🔥 REFUND */}
                            <p className="text-xs text-gray-400">
                              {refundText}
                            </p>

                          </div>

                          {/* RIGHT */}
                          <div className="text-right">
                            <p className="font-semibold text-lg leading-none">
                              {rate.price}€
                            </p>
                            <p className="text-xs text-gray-400 leading-none">
                              / nuit
                            </p>
                          </div>

                        </div>

                      </div>
                    );
                  })}

                </div>

              </div>

              {/* 💰 TOTAL */}
              <div className="mt-6 border-t pt-4">

                <div className="flex justify-between text-sm">
                  <span>Prix total</span>
                  <span className="font-semibold text-lg">
                    {total ? `${total}€` : "..."}
                  </span>
                </div>

              </div>

            </div>

            {/* 🟢 RIGHT = FORM */}
            <div className="bg-white border rounded-2xl p-6">

  <h2 className="text-lg font-semibold mb-4">
    Informations client
  </h2>

  {!isUserReady ? (

    // 🔥 SKELETON PREMIUM
    <div className="flex flex-col gap-3 animate-pulse">

      <div className="h-10 bg-gray-200 rounded-lg"></div>
      <div className="h-10 bg-gray-200 rounded-lg"></div>
      <div className="h-10 bg-gray-200 rounded-lg"></div>
      <div className="h-10 bg-gray-200 rounded-lg"></div>

      <p className="text-xs text-gray-400">
        Chargement de vos informations...
      </p>

    </div>

  ) : (

    // 🔥 FORMULAIRE NORMAL
    <div className="flex flex-col gap-3">

      <input
        value={guest.lastName}
        onChange={(e) =>
          setGuest({ ...guest, lastName: e.target.value })
        }
        placeholder="Nom"
        className="border rounded-lg px-3 py-2 text-sm"
      />

      <input
        value={guest.firstName}
        onChange={(e) =>
          setGuest({ ...guest, firstName: e.target.value })
        }
        placeholder="Prénom"
        className="border rounded-lg px-3 py-2 text-sm"
      />

      <input
        value={guest.email}
        onChange={(e) =>
          setGuest({ ...guest, email: e.target.value })
        }
        placeholder="Email"
        className="border rounded-lg px-3 py-2 text-sm"
      />

      <PhoneInput
        country={"km"}
        value={guest.phone?.replace("+", "")}
        onChange={(phone) =>
          setGuest(prev => ({
            ...prev,
            phone: "+" + phone
          }))
        }
        inputStyle={{
          width: "100%",
          height: "42px",
          borderRadius: "8px",
          border: "1px solid #e5e7eb",
          fontSize: "14px"
        }}
        buttonStyle={{
          borderTopLeftRadius: "8px",
          borderBottomLeftRadius: "8px",
        }}
      />

      {user && (
        <p className="text-xs text-gray-500 mb-3">
          Vos informations sont pré-remplies
        </p>
      )}

    </div>

  )}
            <button
              disabled={loadingReserve}
              className={`
                mt-6 w-full py-3 rounded-xl
                font-medium transition
                ${loadingReserve
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-[#3A9D23] text-white hover:bg-[#33891E]"
                }
              `}
              onClick={handleReserve}
            >
              {loadingReserve ? "Réservation..." : "Confirmer la réservation"}
            </button>

</div>

        </div>

        </div>
    </>
  );
}

export default Checkout;